var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 40.5,
    rx: 14,
    ry: 2.5,
    fill: "black",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4944_25089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 19C38 27.2843 31.8386 34 24.2381 34C16.6376 34 13.3433 33.375 13.3433 19C13.3433 4.9375 16.6376 4 24.2381 4C31.8386 4 38 10.7157 38 19Z",
    fill: "#DD800F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7616 34C14.1611 34 7.99969 27.2843 7.99969 19C7.99969 10.7157 14.1611 4 21.7616 4C29.362 4 35.5234 10.7157 35.5234 19C35.5234 27.2843 29.362 34 21.7616 34Z",
    fill: "url(#paint0_linear_4944_25089)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5097 15.077C32.4886 20.4602 30.089 26.5726 25.1501 28.7295C20.2113 30.8864 14.6034 28.2709 12.6245 22.8878C10.6457 17.5046 13.0452 11.3921 17.9841 9.23525C22.9229 7.07837 28.5309 9.69381 30.5097 15.077Z",
    fill: "#F39E09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8884 9.95089C23.8273 7.79401 26.8633 9.95091 28.2436 11.3985C25.3297 13.1678 18.2407 20.7942 16.7413 27.6436C9.99333 21.3708 13.9496 12.1078 18.8884 9.95089Z",
    fill: "#FFAA16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4465 28.9185C16.4677 27.8001 14.8369 25.9343 13.943 23.5027C11.9648 18.1212 14.3653 12.0063 19.3026 9.85017C21.5335 8.87588 23.8977 8.87337 26.0063 9.66123C23.6018 8.30604 20.6951 8.0513 17.9841 9.23525C13.0468 11.3914 10.6463 17.5063 12.6245 22.8878C13.7089 25.8375 15.8868 27.9585 18.4465 28.9185Z",
    fill: "#E88102",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0221 17.2494C29.3213 16.8735 29.0654 16.3036 28.5973 16.3036H23.1009C22.7067 16.3036 22.4393 15.8847 22.591 15.5047L24.601 10.4674C24.8448 9.85623 22.795 9.36746 22.3897 9.87663L15.3367 20.3403C15.0375 20.7162 15.2934 21.2861 15.7615 21.2861H21.2579C21.6521 21.2861 21.9194 21.705 21.7678 22.085L18.4812 27.4555C18.2373 28.0668 20.2871 28.2222 20.6925 27.713L29.0221 17.2494Z",
    fill: "#E88711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6412 17.2494C27.9404 16.8735 27.6845 16.3036 27.2164 16.3036H21.72C21.3258 16.3036 21.0585 15.8847 21.2101 15.5047L23.2201 10.4674C23.464 9.85623 22.6908 9.36746 22.2854 9.87663L13.9558 20.3403C13.6566 20.7162 13.9125 21.2861 14.3806 21.2861H19.877C20.2712 21.2861 20.5386 21.705 20.3869 22.085L18.3769 27.1222C18.1331 27.7334 18.9063 28.2222 19.3116 27.713L27.6412 17.2494Z",
    fill: "#FFD83B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6003 6.04298C24.652 5.77835 24.4895 5.51896 24.2354 5.47438C22.7228 5.20888 21.1758 5.22859 19.6675 5.53394C18.0064 5.87021 16.4247 6.54633 15.0128 7.52368C13.6008 8.50103 12.3862 9.76048 11.4384 11.2301C10.5777 12.5646 9.95225 14.0487 9.59035 15.6117C9.52957 15.8742 9.69308 16.1329 9.9454 16.1871C10.1977 16.2413 10.4433 16.0704 10.5047 15.8081C10.8416 14.3709 11.4189 13.0063 12.211 11.7782C13.0902 10.415 14.2168 9.24669 15.5265 8.3401C16.8363 7.43351 18.3034 6.80635 19.8442 6.49442C21.2323 6.21342 22.6556 6.1932 24.0482 6.43337C24.3023 6.47721 24.5487 6.30761 24.6003 6.04298Z",
    fill: "#FFE77E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5015 30.742C21.5224 31.0113 21.7476 31.2128 22.0034 31.1812C24.8314 30.8324 27.4701 29.5102 29.5058 27.4221C29.69 27.2332 29.682 26.9229 29.4954 26.7367C29.3088 26.5506 29.0142 26.5591 28.8295 26.7475C26.9526 28.6619 24.5274 29.8771 21.9279 30.2055C21.6722 30.2378 21.4807 30.4728 21.5015 30.742Z",
    fill: "#FFE77E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4944_25089",
    x: -0.000488281,
    y: 0,
    width: 46.0005,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4944_25089"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4944_25089",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4944_25089",
    x1: 21.7616,
    y1: 4,
    x2: 21.7616,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#FFBF1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC536"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsIcon);
export default __webpack_public_path__ + "static/media/coins-icon.ddfcae8818729f1335a700f87e561464.svg";
export { ForwardRef as ReactComponent };